const productCard = document.querySelectorAll('.js-product-card');

productCard.forEach((elem, i) => {

  const handle = elem.getAttribute('data-product-form');

  fetch('/products/' + handle + '.js')
  .then(function(response) {
    response.json().then(data => {
      let product = data;
      let variants = product.variants;

      const cardDropdown = elem.querySelectorAll('.js-dropdown');

      if(cardDropdown) {
        cardDropdown.forEach((form, i) => {
          form.onchange = function () {
            const currentFlavor = elem.querySelector('.js-dropdown option:checked');
            const currentSize = elem.querySelector('.js-radio-content input:checked');
            variants.forEach((variant, i) => {
              if(variant.options.includes(currentFlavor.value) && variant.options.includes(currentSize.value)) {
                let selectedVariantId = variant.id;
                let isAvailable = variant.available;
                elem.querySelector('.product-variant-id').value = selectedVariantId;
                if(isAvailable) {
                  console.log('available');
                  elem.querySelector('.quick-add__submit').disabled = false;
                  elem.querySelector('.js-cta-label').innerHTML = 'Add to cart';
                  elem.querySelector('.js-price').innerHTML = '$' + (variant.price/100);
                } else {
                  console.log('not available');
                  elem.querySelector('.quick-add__submit').disabled = true;
                  elem.querySelector('.js-cta-label').innerHTML = 'Sold Out';
                  elem.querySelector('.js-price').innerHTML = '';
                }

                elem.querySelector('.product__link').href = product.url + '?variant=' + selectedVariantId;
              }
            });
          }
        });
      }

      const cardRadio = elem.querySelectorAll('.js-radio-content');

      if(cardRadio) {
        cardRadio.forEach((form, i) => {

          form.onchange = function () {
            const currentFlavor = elem.querySelector('.js-dropdown option:checked');

            if(!currentFlavor) {
              const currentFlavor = elem.querySelector('.js-only-flavor');

              currentFlavorValue = currentFlavor.innerHTML;
            } else {
              currentFlavorValue = currentFlavor.value;
            }

            const currentSize = elem.querySelector('.js-radio-content input:checked');

            variants.forEach((variant, i) => {
              if(variant.options.includes(currentFlavorValue) && variant.options.includes(currentSize.value)) {

                let selectedVariantId = variant.id;
                let isAvailable = variant.available;

                // let productCardMetaSource =  elem.querySelector('.hidden-variant-metafields-container').innerHTML;
                // let productCardMetaData = JSON.parse(productCardMetaSource);

                elem.querySelector('.product-variant-id').value = selectedVariantId;

                // elem.querySelector('.product-card__img--bg img').src = productCardMetaData[selectedVariantId].image_lit;
                // elem.querySelector('.product-card__img--fore img').src = productCardMetaData[selectedVariantId].image_unlit;

                if(isAvailable) {
                  console.log('available');
                  elem.querySelector('.quick-add__submit').disabled = false;
                  elem.querySelector('.js-cta-label').innerHTML = 'Add to cart';
                  elem.querySelector('.js-price').innerHTML = '$' + (variant.price/100);
                } else {
                  console.log('not available');
                  elem.querySelector('.quick-add__submit').disabled = true;
                  elem.querySelector('.js-cta-label').innerHTML = 'Sold Out';
                  elem.querySelector('.js-price').innerHTML = '';
                }

                elem.querySelector('.product__link').href = product.url + '?variant=' + selectedVariantId;
                elem.querySelector('.quick-add__submit').dataset.id = selectedVariantId;
              }
            });

          }
        });
      }

    });
  })
  .catch(function(error) {
    console.log(error);
  });
});